import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useToggle } from '../../../../infra/small-tools/use-toggle';
import { InviteEngage } from './invite-button';
import { BannerType, useBannerVisibility } from '../../banners';
import { useSetupEngageBanner } from '../../banners/hooks/use-setup-engage-banner';
export var InviteButtonContainer = function (_a) {
    var title = _a.title, variant = _a.variant;
    var shouldShowBanner = useBannerVisibility(BannerType.Share).shouldShowBanner;
    var inviteModalOpen = useToggle(false);
    var handleOpenInviteModal = useCallback(function () {
        inviteModalOpen.setOn();
    }, [inviteModalOpen]);
    useSetupEngageBanner({
        bannerType: BannerType.Share,
        onPrimaryClick: handleOpenInviteModal,
    });
    return (_jsx(InviteEngage, { isOpen: inviteModalOpen.isOn, onClose: inviteModalOpen.setOff, onOpen: handleOpenInviteModal, showBannerMark: shouldShowBanner, title: title, variant: variant }));
};
